var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvalanche(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E84142"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20.5936 11.2937L16.4063 5.3125C16.0538 4.8953 15.9434 4.8953 15.591 5.3125L11.4038 11.2937C11.0513 11.711 11.0513 12.1284 11.4038 12.5457L15.591 18.5457C15.9434 18.963 16.0538 18.963 16.4063 18.5457L20.5936 12.5457C20.946 12.1284 20.946 11.711 20.5936 11.2937"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M24.9085 22.4386L21.8901 17.7386C21.5376 17.3213 21.4272 17.3213 21.0747 17.7386L18.0564 22.4386C17.7039 22.8559 17.7039 23.2732 18.0564 23.6903L21.0747 28.3906C21.4272 28.8079 21.5376 28.8079 21.8901 28.3906L24.9085 23.6903C25.261 23.2732 25.261 22.8559 24.9085 22.4386"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.9297 22.4386L10.9113 17.7386C10.5589 17.3213 10.4485 17.3213 10.096 17.7386L7.07757 22.4386C6.72508 22.8559 6.72508 23.2732 7.07757 23.6903L10.096 28.3906C10.4485 28.8079 10.5589 28.8079 10.9113 28.3906L13.9297 23.6903C14.2822 23.2732 14.2822 22.8559 13.9297 22.4386"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/avalanche.6f826536c71e7e9a3a12a4df0669dc83.svg";
export { ForwardRef as ReactComponent };